import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { SupportComponent } from './support/support.component';

const routes: Routes = [
  { path: '', redirectTo: '/support', pathMatch: 'full' }, // 첫 화면을 메인 페이지로 설정
  { path: 'privacy', component:PrivacyComponent},
  { path: 'terms', component:TermsComponent},
  { path: 'support', component:SupportComponent},
  { path: '**', redirectTo: '', pathMatch: 'full' } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
